var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-warp",style:(_vm.styles)},[(_vm.$slots.default)?[_vm._t("default")]:[_c('img',{staticClass:"image",style:(_vm.imageStyles),attrs:{"src":require("@/assets/images/icon-nodata.png")}}),_vm._v(" "),_c('div',{staticClass:"text",style:(_vm.textStyles)},[_vm._v(_vm._s(_vm.text))])]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f36c4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/defaultPic.vue
// module id = ZaMn
// module chunks = 0